import type { IAppSubRoute } from 'routes/types';
import { OptionalRoutesEnum } from 'routes/enums';

import { ResponsibilityLetterPage } from './index';

export const ResponsibilityLetterRouter: IAppSubRoute = {
  Page: ResponsibilityLetterPage,
  path: OptionalRoutesEnum.RESPONSIBILITY_LETTER,
  optionalRoute: OptionalRoutesEnum.RESPONSIBILITY_LETTER,
  name: 'Carta de responsabilidade',
  isPrivate: true,
};
